





















import {
    computed,
    defineComponent,
    PropType,
} from '@vue/composition-api';
import { SportId } from '@core/constants';
import { SdsIcon } from '@superbet-group/web.lib.ui-components';

const serveIconsMap: Partial<Record<SportId, any>> = {
    [SportId.Tennis]: 'match-events-tennis-point',
    [SportId.Badminton]: 'match-events-badminton-serve',
    [SportId.Volleyball]: 'match-events-volleyball-serve',
    [SportId.TableTennis]: 'match-events-table-tennis-serve',
};

export default defineComponent({
    name: 'EventCompetitor',
    props: {
        isLeading: {
            type: Boolean,
            default: false,
        },
        isLive: {
            type: Boolean,
            required: true,
        },
        hasIcon: {
            type: Boolean,
            default: false,
        },
        competitorName: {
            type: String,
            required: true,
        },
        isServing: {
            type: Boolean,
            default: false,
        },
        yellowCards: {
            type: Number,
            default: 0,
        },
        redCards: {
            type: Number,
            default: 0,
        },
        sportId: {
            type: Number as PropType<SportId | undefined>,
            default: undefined,
        },
        canWrap: {
            type: Boolean,
            required: false,
            default: false,
        },
        e2eClass: {
            type: String,
            required: false,
            default: '',
        },
    },
    setup(props) {
        const iconName = computed(() => {
            if (props.redCards > 0) {
                return 'match-events-soccer-card-red';
            } else if (props.isServing && props.sportId && props.sportId in serveIconsMap) {
                return serveIconsMap[props.sportId];
            } else {
                return null;
            }
        });
        return {
            iconName,
        };
    },
    components: { SdsIcon },
});
